import React from "react";
import axios from "axios";
import AttendeeView from "./AttendeeView";
import "./styles/calibration.css";
import webgazer from "../webgazer/src/";

class CalibrationView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      calibrationCompleted: false,
      attendeeId: props.attendeeId,
      meetingId: props.meetingId,
      PointCalibrate: 0,
      CalibrationPoints: {},
    };
  }

  store_points_variable = () => {
    webgazer.params.storingPoints = true;
  };
  stop_storing_points_variable = () => {
    webgazer.params.storingPoints = false;
  };

  calculatePrecision = (past50Array) => {
    const calculatePrecisionPercentages = (
      precisionPercentages,
      windowHeight,
      x50,
      y50,
      staringPointX,
      staringPointY
    ) => {
      for (var x = 0; x < 50; x++) {
        // Calculate distance between each prediction and staring point
        var xDiff = staringPointX - x50[x];
        var yDiff = staringPointY - y50[x];
        var distance = Math.sqrt(xDiff * xDiff + yDiff * yDiff);

        // Calculate precision percentage
        var halfWindowHeight = windowHeight / 2;
        var precision = 0;
        if (distance <= halfWindowHeight && distance > -1) {
          precision = 100 - (distance / halfWindowHeight) * 100;
        } else if (distance > halfWindowHeight) {
          precision = 0;
        } else if (distance > -1) {
          precision = 100;
        }

        // Store the precision
        precisionPercentages[x] = precision;
      }
    };

    /*
     * Calculates the average of all precision percentages calculated
     */
    const calculateAverage = (precisionPercentages) => {
      var precision = 0;
      for (var x = 0; x < 50; x++) {
        precision += precisionPercentages[x];
      }
      precision = precision / 50;
      return precision;
    };

    var windowHeight = document.height();
    var windowWidth = document.width();

    // Retrieve the last 50 gaze prediction points
    var x50 = past50Array[0];
    var y50 = past50Array[1];

    // Calculate the position of the point the user is staring at
    var staringPointX = windowWidth / 2;
    var staringPointY = windowHeight / 2;

    var precisionPercentages = new Array(50);
    calculatePrecisionPercentages(
      precisionPercentages,
      windowHeight,
      x50,
      y50,
      staringPointX,
      staringPointY
    );
    var precision = calculateAverage(precisionPercentages);

    // Return the precision measurement as a rounded percentage
    return Math.round(precision);
  };

  handleClicked = (event) => {
    const id = event.target.id;
    if (!this.state.CalibrationPoints[id]) {
      this.state.CalibrationPoints[id] = 0;
    }
    this.state.CalibrationPoints[id]++; // increments values
    if (this.state.CalibrationPoints[id] == 5) {
      //only turn to yellow after 4 clicks
      document.getElementById(id).setAttribute("class", "CalibrationDone");
      document.getElementById(id).setAttribute("disabled", ""); //disables the button
      this.state.PointCalibrate++;
      console.log(this.state.PointCalibrate);
    } else if (this.state.CalibrationPoints[id] < 4) {
      //Gradually increase the opacity of calibration points when click to give some indication to user.
      var opacity = 0.25 * this.state.CalibrationPoints[id] + 0.25;
      document.getElementById(id).style.opacity = opacity;
    }

    if (this.state.PointCalibrate >= 9) {
      this.setState({
        calibrationCompleted: true,
      });
      console.log("completed calibration");
      // code below for calculating precision
      //   this.store_points_variable();
      //   this.stop_storing_points_variable();
      //   var past50 = webgazer.getStoredPoints();
      //   var precision_measurement = this.calculatePrecision(past50);
    }
  };

  render() {
    return (
      <div>
        {!this.state.calibrationCompleted ? (
          <div>
            <div id="calibrationLabel">
              Please click on each of the 9 points on the screen. You must click
              on each point 4 times till it goes yellow. This will calibrate
              your eye movements.
            </div>

            <div class="calibrationDiv">
              <input
                type="button"
                class="Calibration"
                id="Pt1"
                onClick={this.handleClicked}
              ></input>
              <input
                type="button"
                class="Calibration"
                id="Pt2"
                onClick={this.handleClicked}
              ></input>
              <input
                type="button"
                class="Calibration"
                id="Pt3"
                onClick={this.handleClicked}
              ></input>
              <input
                type="button"
                class="Calibration"
                id="Pt4"
                onClick={this.handleClicked}
              ></input>
              <input
                type="button"
                class="Calibration"
                id="Pt5"
                onClick={this.handleClicked}
              ></input>
              <input
                type="button"
                class="Calibration"
                id="Pt6"
                onClick={this.handleClicked}
              ></input>
              <input
                type="button"
                class="Calibration"
                id="Pt7"
                onClick={this.handleClicked}
              ></input>
              <input
                type="button"
                class="Calibration"
                id="Pt8"
                onClick={this.handleClicked}
              ></input>
              <input
                type="button"
                class="Calibration"
                id="Pt9"
                onClick={this.handleClicked}
              ></input>
            </div>
          </div>
        ) : (
          <AttendeeView
            attendeeId={this.props.attendeeId}
            meetingId={this.props.meetingId}
          />
        )}
      </div>
    );
  }
}

export default CalibrationView;
